import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  Box,
  Button,
  Grid,
  Link,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import DigitalPolicy from '../../../../assets/img/digitalPolicy_orange.svg';
// import DigitalPolicy from '../../../../assets/img/digitalPolicy.svg';
// import SumAssured from '../../../../assets/img/sumaAsegurada.svg';
// import Vehicle from '../../../../assets/img/vehicle.svg';
import { ReactComponent as OkIcon } from '../../../../assets/img/icon/Ok.svg';
import SumAssured from '../../../../assets/img/sumaAsegurada_orange.svg';
import Vehicle from '../../../../assets/img/vehicle_orange.svg';
//import AccesoriesDisabled from '../../../../assets/img/accesoriosDisabled.svg';
//import AddDriverDisabled from '../../../../assets/img/agregarConductorDisabled.svg';
//import AssistanceDisabled from '../../../../assets/img/asistenciaDisabled.svg';
//import PolicyDisabled from '../../../../assets/img/polizaDisabled.svg';
//import SecuredClause from '../../../../assets/img/secured_clause_disabled.png';
import WhatsappSrc from '../../../../assets/img/whatsapp.svg';
// import WhatsappSrc from '../../../../assets/img/whatsapp.png';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import SuraCard from '../../../../components/SuraCard';
import { appConfig } from '../../../../config/app';
import { ANSWER } from '../../../../constants/website.constant';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import {
  ENDORSEMENTS,
  useEndorsementsDataContext,
} from '../../../../context/endorsements/endorsements.provider';
import { useVehiclesContext } from '../../../../context/vehicles/vehicles.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';
import {
  policies as getPolicyById,
  sumAssured,
} from '../../../../services/policy/policy.service';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    selectionCard: {
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      cursor: 'pointer',
      minHeight: '140px',
      '& img': {
        objectFit: 'fill',
      },
    },
    borderedCard: {
      border: '1px solid #FA6400',
    },
    check: {
      position: 'relative',
      top: '5%',
      right: '5%',
    },
    checked: {
      '& path': {
        stroke: '#FA6400',
      },
    },
  })
);

const Part = (props: any) => {
  const {
    title,
    subtitle,
    img,
    onChange,
    checked,
    disabled,
    extraDescription = 'Próximamente',
  } = props;
  const classes = useStyle();
  const [, setSelected] = useState(checked);

  const selectCard = () => {
    onChange(!checked);
    setSelected(checked);
  };

  const cardStyles =
    classes.selectionCard + (checked ? ' ' + classes.borderedCard : '');
  const checkStyles = classes.check + (checked ? ' ' + classes.checked : '');

  return (
    <Box m={1} onClick={disabled ? undefined : selectCard}>
      <SuraCard className={cardStyles}>
        <Box p={3} pl={0} display="flex" width={'85%'}>
          <Box m={1}>
            {' '}
            <img src={img} alt="part" />{' '}
          </Box>

          <Box ml={2}>
            <Typography
              // color={disabled ? 'textPrimary' : 'primary'}
              variant="h6"
              align="left"
            >
              {title}
            </Typography>
            <Typography align="left">{subtitle}</Typography>
            {disabled && (
              <Typography
                align="left"
                variant="caption"
                color={disabled ? 'secondary' : 'error'}
              >
                {extraDescription}
              </Typography>
            )}
          </Box>
        </Box>
        <OkIcon className={checkStyles} />
      </SuraCard>
    </Box>
  );
};

const stateFalseMock = {
  vehicle: false,
  digital_policy: false,
  policy: false,
  assistance: false,
  accesories: false,
  sum_assured: false,
  add_driver: false,
  secured_clause: false,
};

const SelectEndorsement = () => {
  const { vehicle: currentVehicle } = useVehiclesContext();
  const {
    nextStep,
    onSelectedEndorsement,
    updateEndorsementBody,
    setLoaderHelper,
  } = useEndorsementsDataContext();
  const { user } = useAuthDataContext();
  const [policyInfo, setPolicyInfo] = useState({});
  const [state, setState] = useState<any>({
    vehicle: false,
    digital_policy: false,
    policy: false,
    assistance: false,
    accesories: false,
    sum_assured: false,
    add_driver: false,
    secured_clause: false,
  });

  const [openErrors, setOpenErrors] = useState(false);
  const [element, setElement] = useState<any>('default');
  const [open, setOpen] = useState(false);
  const history = useHistory();

  const {
    policy,
    assistance,
    accesories,
    vehicle,
    sum_assured,
    add_driver,
    secured_clause,
    digital_policy,
  } = state;

  useEffect(() => {
    dataLayerPush('modificar_poliza_detalles', user?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getPolicy();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCheckboxChange = (name: string) => (value: boolean) => {
    onSelectedEndorsement(name, value);
    setState({ ...stateFalseMock, [name]: value });
  };

  const isDisabled = () => {
    const check = Object.values(state).some((element) => element === true);
    return !check;
  };

  const getPolicy = async () => {
    await getPolicyById(currentVehicle.id).then((policyData) => {
      if (!policyData.data) {
        alert('error aqui');
      }
      setPolicyInfo(policyData.data);
      updateEndorsementBody({ policyInfo: policyData.data });
    });
  };

  const handleSubmit = () => {
    dataLayerPush('modificar_poliza_cancelar_poliza', user?.id);
    if (currentVehicle.policy.vehicles_amount > 1) {
      setOpen(true);
    } else {
      history.push('/cancel-policy/' + currentVehicle.policy.id);
    }
  };

  // Modal Content
  const getContent = (modalCasesInfo) => {
    if (modalCasesInfo.afinnity) {
      //case afinnity
      return (
        <Box>
          <Typography variant="h6" style={{ marginBottom: '15px' }}>
            Para modificar tu suma asegurada.
          </Typography>
          <Typography>
            Por favor comunicate con nosotros por Whatsapp de lunes a viernes de
            09 a 18 Hs. para poder gestionar tu pedido.
          </Typography>
        </Box>
      );
    } else if (modalCasesInfo.companyProducer) {
      // companyProducer
      return (
        <Box>
          <Typography variant="h6" style={{ marginBottom: '15px' }}>
            Para modificar tu suma asegurada.
          </Typography>
          <Typography>
            Por favor comunicate con tu productor/asesor para poder gestionar tu
            pedido.
          </Typography>
        </Box>
      );
    } else if (modalCasesInfo.RC_afinnity) {
      // RC_affinity
      return (
        <Box>
          <Typography variant="h6" style={{ marginBottom: '15px' }}>
            Para modificar tu suma asegurada.
          </Typography>
          <Typography>
            Por favor comunicate con nosotros por Whatsapp de lunes a viernes de
            09 a 18 Hs. para poder gestionar tu pedido.
          </Typography>
        </Box>
      );
    } else if (modalCasesInfo.RC_Company_Producer) {
      return (
        <Box>
          <Typography variant="h6" style={{ marginBottom: '15px' }}>
            Para modificar tu suma asegurada
          </Typography>
          <Typography>
            Por favor comunicate con tu productor/asesor para poder gestionar tu
            pedido.
          </Typography>
        </Box>
      );
    } else if (modalCasesInfo.retryModal) {
      // GW no responde
      return (
        <Box>
          <Typography variant="h6" style={{ marginBottom: '15px' }}>
            Ha ocurrido un error.
          </Typography>
          <Typography>
            ¡Lo sentimos! El cambio no puede procesarse. Te pedimos que
            reintentes en otro momento.
          </Typography>
        </Box>
      );
    } else {
      // GW no responde default
      return (
        <Box>
          <Typography variant="h6" style={{ marginBottom: '15px' }}>
            Ha ocurrido un error.
          </Typography>
          <Typography>
            ¡Lo sentimos! El cambio no puede procesarse. Te pedimos que
            reintentes en otro momento.
          </Typography>
        </Box>
      );
    }
  };

  const { embed } = useAuthDataContext();
  const redirectHome = () => {
    embed
      ? window.parent.postMessage({ return: 'overview' }, '*')
      : history.push('/dashboard');
  };

  // Modal Actions
  const getActions = () => {
    //affinity o RC_affinity van con whatsapp
    return (
      <Grid container>
        <Grid item xs={12} sm={12}>
          <Box style={{ margin: '8px 16px' }}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={redirectHome}
            >
              Entendido
            </Button>
          </Box>
        </Grid>
        {ANSWER && (
          <Grid item xs={12} sm={12}>
            <Box m={2}>
              <Link
                href={appConfig?.WHATSAPP_LINK}
                rel="noopener"
                target="_blank"
              >
                <Button variant="outlined" fullWidth color="secondary">
                  <Box>
                    <img
                      src={WhatsappSrc}
                      alt="Whatsapp"
                      style={{ marginLeft: '15px', marginRight: '15px' }}
                    />
                  </Box>
                  <Typography display="inline">
                    Comunicarme vía Whatsapp
                  </Typography>
                </Button>
              </Link>
            </Box>
          </Grid>
        )}
      </Grid>
    );
  };

  const handleNextStep = async () => {
    let endorsementSelected: string[] = [];
    let sumInsuranceData: any = {};

    if (state.sum_assured === true) {
      setLoaderHelper(true);

      await sumAssured(currentVehicle.policy.id, currentVehicle.id)
        .then((data) => {
          sumInsuranceData = {
            ...data.data,
            http_code: data.status,
            catch: false,
          };
          setLoaderHelper(false);
          // Aqui mostrar modales de error
        })
        .catch((err) => {
          setLoaderHelper(false);
          // ver que trae el catch con errores 400
          sumInsuranceData = {
            ...err.response.data,
            http_code: err.response.status,
            catch: true,
          };
        });
    }

    let modalCases = {
      afinnity:
        sumInsuranceData.http_code === 202 &&
        sumInsuranceData.code === 101 &&
        policyInfo[0]?.provider?.grouped_company !== 'sura',

      companyProducer:
        sumInsuranceData.http_code === 202 &&
        sumInsuranceData.code === 101 &&
        policyInfo[0]?.provider?.grouped_company === 'sura',

      RC_afinnity:
        sumInsuranceData.http_code === 409 &&
        policyInfo[0]?.provider?.grouped_company !== 'sura',

      RC_Company_Producer:
        sumInsuranceData.http_code === 409 &&
        policyInfo[0]?.provider?.grouped_company === 'sura',

      retryModal:
        sumInsuranceData.http_code === 400 && sumInsuranceData.code === 110,

      default: sumInsuranceData.catch,
    };

    if (Object.values(modalCases).some((element) => element === true)) {
      setElement(getContent(modalCases));
      setOpenErrors(true);
    } else {
      if (state.sum_assured === true) {
        updateEndorsementBody({
          sumInsuredData: {
            ...sumInsuranceData,
            initialValue: sumInsuranceData?.totalsum,
            /* maximum_rate: 1094130,
          minimum_rate: 694130 */
          },
        });
      }

      Object.keys(state).forEach((endorsementName: any) => {
        state[endorsementName] === true &&
          endorsementSelected.push(ENDORSEMENTS[endorsementName].title);
      });
      dataLayerPush('modificar_poliza_opciones', user?.id, {
        fieldName: 'opcion_mod_poliza',
        fieldValue: endorsementSelected,
      });
      nextStep();
    }
  };

  return (
    <>
      <SharedDialog
        open={open}
        content={
          <Box>
            <Typography variant="h6" style={{ marginBottom: '15px' }}>
              Importante
            </Typography>
            <Typography>
              Si tu póliza posee más de un riesgo, tu solicitud se procesará por
              la totalidad de vehículos asegurados.
            </Typography>
          </Box>
        }
        onClose={() => setOpen(false)}
        actions={
          <Grid container>
            <Grid item xs={12} sm={12}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => history.push('/cancel-policy')}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      {openErrors && (
        <SharedDialog
          open={openErrors}
          onClose={() => setOpenErrors(false)}
          content={<Box>{element}</Box>}
          actions={getActions()}
        ></SharedDialog>
      )}

      <Grid container>
        <Grid container item lg={12}>
          <Box my={3}>
            <Typography variant="h6" style={{ marginTop: '15px' }}>
              ¿Qué necesitás modificar?
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container>
        <Grid container>
          <Grid item xs={12} md={6}>
            <Part
              img={Vehicle}
              title={'Vehículo'}
              subtitle={'Cambio de Patente, Motor y Chasis'}
              checked={vehicle}
              onChange={handleCheckboxChange('vehicle')}
              disabled={!currentVehicle.can_request_endorsement}
              extraDescription={
                'Tu solicitud de actualización de datos está en proceso.'
              }
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Part
              img={DigitalPolicy}
              title={'Póliza digital'}
              subtitle={'Suscribite o realizá cambios'}
              checked={digital_policy}
              onChange={handleCheckboxChange('digital_policy')}
              disabled={!currentVehicle.can_request_endorsement}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Part
              img={SumAssured}
              title={'Suma asegurada'}
              subtitle={'Aumentar suma asegurada'}
              checked={sum_assured}
              onChange={handleCheckboxChange('sum_assured')}
            />
          </Grid>
          {/* <Grid item xs={12} md={6}>
            <Part
              img={SecuredClause}
              title={'Cláusula de ajuste'}
              subtitle={'Aumentar cláusula según porcentaje'}
              checked={secured_clause}
              disabled
              onChange={handleCheckboxChange('secured_clause')}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Part
              img={PolicyDisabled}
              title={'Póliza'}
              subtitle={'Cambio de cobertura'}
              checked={policy}
              disabled
              onChange={handleCheckboxChange('policy')}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Part
              img={AssistanceDisabled}
              title={'Asistencia'}
              subtitle={'Básica, Medium, Premium'}
              checked={assistance}
              disabled
              onChange={handleCheckboxChange('assistance')}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Part
              img={AccesoriesDisabled}
              title={'Accesorios'}
              subtitle={'GNC, Stéreo, Llantas + cubiertas, Granizo'}
              checked={accesories}
              disabled
              onChange={handleCheckboxChange('accesories')}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Part
              img={AddDriverDisabled}
              title={'Agregar conductor'}
              subtitle={'Sumar un conductor a la póliza'}
              checked={add_driver}
              disabled
              onChange={handleCheckboxChange('add_driver')}
            />
          </Grid> */}
        </Grid>
      </Grid>
      <Grid container item lg={12} />
      {/* <Grid container item lg={12}>
        <Box my={3}>
          <Typography
            variant="h6"
            color="primary"
            onClick={handleSubmit}
            style={{ cursor: 'pointer' }}
          >
            Cancelar póliza
          </Typography>
        </Box>
      </Grid> */}
      <Grid container justify="center">
        <Grid item xs={12} sm={6}>
          <Box style={{ marginTop: '10px', marginBottom: '10px' }}>
            <Button
              variant="contained"
              color="primary"
              fullWidth={true}
              disabled={isDisabled()}
              onClick={() => handleNextStep()}
            >
              Continuar
            </Button>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default SelectEndorsement;
